import { axiosInstance } from "./config";

export const logClientAction = (action, module, metadata = {}) => {
  return axiosInstance.post("/logs/client", {
    action,
    module,
    metadata,
  });
};
